/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { LoginCodeToJSON, LoginDataToJSON, LogoutRequestToJSON, PasskeyFromJSON, PasskeySignalFromJSON, RecoveryGrantFromJSON, ResetPasswordRequestToJSON, SessionInfoFromJSON, SetPasswordToJSON, TokenFromJSON, } from '../models/index';
/**
 *
 */
export class AuthenticationApi extends runtime.BaseAPI {
    /**
     * Delete a passkey and return the Signal API payload.  The response lists the credentials still valid for this user so the client can call ``PublicKeyCredential.signalAllAcceptedCredentials()``: the passkey provider then deletes its local copy of the removed key immediately, instead of keeping an orphan that would be suggested at the next login and fail.
     * Delete Passkey
     */
    deletePasskeyApiV1WebauthnCredentialIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['credentialId'] == null) {
                throw new runtime.RequiredError('credentialId', 'Required parameter "credentialId" was null or undefined when calling deletePasskeyApiV1WebauthnCredentialIdDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/webauthn/{credential_id}`.replace(`{${"credential_id"}}`, encodeURIComponent(String(requestParameters['credentialId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PasskeySignalFromJSON(jsonValue));
        });
    }
    /**
     * Delete a passkey and return the Signal API payload.  The response lists the credentials still valid for this user so the client can call ``PublicKeyCredential.signalAllAcceptedCredentials()``: the passkey provider then deletes its local copy of the removed key immediately, instead of keeping an orphan that would be suggested at the next login and fail.
     * Delete Passkey
     */
    deletePasskeyApiV1WebauthnCredentialIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deletePasskeyApiV1WebauthnCredentialIdDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * List Passkeys
     */
    listPasskeysApiV1WebauthnGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/webauthn/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PasskeyFromJSON));
        });
    }
    /**
     * List Passkeys
     */
    listPasskeysApiV1WebauthnGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listPasskeysApiV1WebauthnGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Return all accounts currently signed in this browser (multi-account).  Public endpoint (no auth dependency): it only reflects the cookies the caller already holds and never reveals anything about accounts whose signed session cookie is not present.
     * List Sessions
     */
    listSessionsApiV1AuthSessionsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/auth/sessions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SessionInfoFromJSON));
        });
    }
    /**
     * Return all accounts currently signed in this browser (multi-account).  Public endpoint (no auth dependency): it only reflects the cookies the caller already holds and never reveals anything about accounts whose signed session cookie is not present.
     * List Sessions
     */
    listSessionsApiV1AuthSessionsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listSessionsApiV1AuthSessionsGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Sign the member in from an emailed recovery grant (grant id + code).  Single consumption endpoint of the recovery email, for every account type. The grant id publicly identifies the request; the 6-digit code is the secret (RFC 8628\'s device_code/user_code split). The email offers it two ways: the code to type into the page that requested it — the primary path, keeping the session (and the passkey ceremony that may follow) in a real browser instead of an email app\'s WebView — and a link that is this same call with both fields prefilled in its URL (verification_uri_complete pattern). Also the landing of the welcome email sent when staff creates a member by hand.  Proving control of the email is a full authentication (same reasoning as the invitation-accept flow), so the member lands signed in (additive session cookies, becomes the active account) and the client offers how to secure the next sign-in: a passkey, or a new password for accounts that had one.  Guessing is bounded by the attempt counter (then the grant is revoked) and the grant\'s short lifetime. Every failure returns the same 403 so the endpoint reveals nothing about account existence, pending recoveries, or grant-id validity (decoy grant ids answer identically).
     * Login With Code
     */
    loginWithCodeApiV1AuthLoginCodePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['loginCode'] == null) {
                throw new runtime.RequiredError('loginCode', 'Required parameter "loginCode" was null or undefined when calling loginWithCodeApiV1AuthLoginCodePost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/v1/auth/login_code`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: LoginCodeToJSON(requestParameters['loginCode']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
        });
    }
    /**
     * Sign the member in from an emailed recovery grant (grant id + code).  Single consumption endpoint of the recovery email, for every account type. The grant id publicly identifies the request; the 6-digit code is the secret (RFC 8628\'s device_code/user_code split). The email offers it two ways: the code to type into the page that requested it — the primary path, keeping the session (and the passkey ceremony that may follow) in a real browser instead of an email app\'s WebView — and a link that is this same call with both fields prefilled in its URL (verification_uri_complete pattern). Also the landing of the welcome email sent when staff creates a member by hand.  Proving control of the email is a full authentication (same reasoning as the invitation-accept flow), so the member lands signed in (additive session cookies, becomes the active account) and the client offers how to secure the next sign-in: a passkey, or a new password for accounts that had one.  Guessing is bounded by the attempt counter (then the grant is revoked) and the grant\'s short lifetime. Every failure returns the same 403 so the endpoint reveals nothing about account existence, pending recoveries, or grant-id validity (decoy grant ids answer identically).
     * Login With Code
     */
    loginWithCodeApiV1AuthLoginCodePost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.loginWithCodeApiV1AuthLoginCodePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Sign out of a single account and return the remaining sessions.  Deletes only the targeted account\'s session cookie (``account_id`` in the body, defaulting to the active account). Other accounts stay signed in. When no sessions remain the ``active_account`` selector is cleared too. The legacy single-session ``access_token`` cookie is also cleared when it is the thing being logged out, for backward compatibility.  When ``all`` is true, every account signed in this browser is signed out at once (``account_id`` is ignored) and an empty list is returned. This only clears cookies in the current browser; sessions on other devices are not revoked (tokens are stateless and carry no server-side session record).
     * Logout
     */
    logoutApiV1AuthLogoutPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/v1/auth/logout`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: LogoutRequestToJSON(requestParameters['logoutRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SessionInfoFromJSON));
        });
    }
    /**
     * Sign out of a single account and return the remaining sessions.  Deletes only the targeted account\'s session cookie (``account_id`` in the body, defaulting to the active account). Other accounts stay signed in. When no sessions remain the ``active_account`` selector is cleared too. The legacy single-session ``access_token`` cookie is also cleared when it is the thing being logged out, for backward compatibility.  When ``all`` is true, every account signed in this browser is signed out at once (``account_id`` is ignored) and an empty list is returned. This only clears cookies in the current browser; sessions on other devices are not revoked (tokens are stateless and carry no server-side session record).
     * Logout
     */
    logoutApiV1AuthLogoutPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.logoutApiV1AuthLogoutPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Prepare Login
     */
    prepareLoginApiV1AuthLoginGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/auth/login`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Prepare Login
     */
    prepareLoginApiV1AuthLoginGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.prepareLoginApiV1AuthLoginGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Preregister Passkey
     */
    preregisterPasskeyApiV1WebauthnPreregisterGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['flow'] != null) {
                queryParameters['flow'] = requestParameters['flow'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/webauthn/preregister`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Preregister Passkey
     */
    preregisterPasskeyApiV1WebauthnPreregisterGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.preregisterPasskeyApiV1WebauthnPreregisterGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Process Login
     */
    processLoginApiV1AuthLoginPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['loginData'] == null) {
                throw new runtime.RequiredError('loginData', 'Required parameter "loginData" was null or undefined when calling processLoginApiV1AuthLoginPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/v1/auth/login`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: LoginDataToJSON(requestParameters['loginData']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
        });
    }
    /**
     * Process Login
     */
    processLoginApiV1AuthLoginPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.processLoginApiV1AuthLoginPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Register Passkey
     */
    registerPasskeyApiV1WebauthnRegisterPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['requestBody'] == null) {
                throw new runtime.RequiredError('requestBody', 'Required parameter "requestBody" was null or undefined when calling registerPasskeyApiV1WebauthnRegisterPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/webauthn/register`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['requestBody'],
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Register Passkey
     */
    registerPasskeyApiV1WebauthnRegisterPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.registerPasskeyApiV1WebauthnRegisterPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Reset Password Request
     */
    resetPasswordRequestApiV1AuthResetPasswordRequestPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['resetPasswordRequest'] == null) {
                throw new runtime.RequiredError('resetPasswordRequest', 'Required parameter "resetPasswordRequest" was null or undefined when calling resetPasswordRequestApiV1AuthResetPasswordRequestPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/v1/auth/reset_password_request`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ResetPasswordRequestToJSON(requestParameters['resetPasswordRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RecoveryGrantFromJSON(jsonValue));
        });
    }
    /**
     * Reset Password Request
     */
    resetPasswordRequestApiV1AuthResetPasswordRequestPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.resetPasswordRequestApiV1AuthResetPasswordRequestPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Set (or replace) the signed-in member\'s password.  Recovery successor of the old ``POST /auth/reset``: proving control of the email (code or link) already signed the member in, so setting a new password is now an authenticated action instead of a token-bearing one. Deliberately does not require the current password — the flow exists precisely because it was forgotten. The trust boundary is kept at \"proved email control recently\" by requiring a FRESH session (see ``SET_PASSWORD_MAX_SESSION_AGE``): without it, any live session (they last 90 days and cannot be revoked) could quietly take over the account with a password of its own. Also usable later from the account-security settings for members who want a fallback password, behind a fresh re-authentication.
     * Set Password
     */
    setPasswordApiV1AuthSetPasswordPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['setPassword'] == null) {
                throw new runtime.RequiredError('setPassword', 'Required parameter "setPassword" was null or undefined when calling setPasswordApiV1AuthSetPasswordPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/auth/set_password`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SetPasswordToJSON(requestParameters['setPassword']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Set (or replace) the signed-in member\'s password.  Recovery successor of the old ``POST /auth/reset``: proving control of the email (code or link) already signed the member in, so setting a new password is now an authenticated action instead of a token-bearing one. Deliberately does not require the current password — the flow exists precisely because it was forgotten. The trust boundary is kept at \"proved email control recently\" by requiring a FRESH session (see ``SET_PASSWORD_MAX_SESSION_AGE``): without it, any live session (they last 90 days and cannot be revoked) could quietly take over the account with a password of its own. Also usable later from the account-security settings for members who want a fallback password, behind a fresh re-authentication.
     * Set Password
     */
    setPasswordApiV1AuthSetPasswordPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.setPasswordApiV1AuthSetPasswordPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Forward-auth gate for the Mailpit UI (beta).  Reachable through Traefik\'s ``forwardAuth`` middleware, which replays the caller\'s cookies here before serving the internal Mailpit service. A 204 means the browser holds a valid session whose role grants ``VIEW:EMAIL`` (staff/admin); the ``Authorization`` dependency raises 401/403 otherwise. The body is empty on purpose: only the status code matters to Traefik.
     * Verify Email Access
     */
    verifyEmailAccessApiV1AuthVerifyGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/auth/verify`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Forward-auth gate for the Mailpit UI (beta).  Reachable through Traefik\'s ``forwardAuth`` middleware, which replays the caller\'s cookies here before serving the internal Mailpit service. A 204 means the browser holds a valid session whose role grants ``VIEW:EMAIL`` (staff/admin); the ``Authorization`` dependency raises 401/403 otherwise. The body is empty on purpose: only the status code matters to Traefik.
     * Verify Email Access
     */
    verifyEmailAccessApiV1AuthVerifyGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.verifyEmailAccessApiV1AuthVerifyGetRaw(initOverrides);
        });
    }
}
/**
 * @export
 */
export const PreregisterPasskeyApiV1WebauthnPreregisterGetFlowEnum = {
    Explicit: 'explicit',
    Silent: 'silent'
};
